import { Caption1 } from '@fluentui/react-components';
import { Info16Regular } from '@fluentui/react-icons';

import { AI_ASSISTANT_DISCLAIMER } from '../constants';

const AiAssistantDisclaimer = () => (
  <div className="flex items-center gap-1 text-neutralFg-3 shrink-0">
    <Info16Regular className="shrink-0" />
    <Caption1>{AI_ASSISTANT_DISCLAIMER}</Caption1>
  </div>
);

export default AiAssistantDisclaimer;
